import { memo, useContext } from 'react';
import type { ReactNode } from 'react';
import { HStack, VStack } from '@library';
import ProductListViewControls from '../Controls/ProductListViewControls';
import type { ProductsViewMode } from '../../../types';
import FilterButton from '../Filters/FilterButton';
import { ListControls } from '../Controls/ProductListControls';
import ProductListCSVDownloadButton from '../Controls/StocklistControls/ProductListCSVDownloadButton';
import { AppContext } from '../../../../core/context';
import ProductListCategoryHeader from './ProductListCategoryHeader';

const ProductListHeader = ({
    header,
    subHeader,
    headerAction,
    totalLoading = false,
    totalCount = 0,
    filteredTotal = 0,
    viewMode,
    setViewMode,
    openFilters,
}: {
    header?: ReactNode;
    subHeader?: ReactNode;
    headerAction?: ReactNode;
    totalLoading?: boolean;
    totalCount?: number;
    filteredTotal?: number;
    viewMode: ProductsViewMode;
    setViewMode: (value: ProductsViewMode) => void;
    openFilters?: () => void;
}) => {
    const { isInMobileView, isInTabletView } = useContext(AppContext);

    if (isInMobileView) {
        return (
            <VStack gap="medium">
                <VStack gap="mini">
                    <HStack justify="spaceBetween" align="baseline" gap="mini">
                        <ProductListCategoryHeader
                            header={header}
                            subHeader={subHeader}
                            totalLoading={totalLoading}
                            total={totalCount}
                            filteredTotal={filteredTotal}
                            headerAction={headerAction}
                        />
                        <FilterButton onPress={openFilters} />
                    </HStack>

                    <ListControls small />
                </VStack>
            </VStack>
        );
    }
    if (isInTabletView) {
        return (
            <VStack gap="medium">
                <VStack gap="mini">
                    <HStack justify="spaceBetween" align="center">
                        <ProductListCategoryHeader
                            header={header}
                            subHeader={subHeader}
                            totalLoading={totalLoading}
                            total={totalCount}
                            filteredTotal={filteredTotal}
                            headerAction={headerAction}
                        />
                        <ListControls small />
                    </HStack>
                    <HStack justify="spaceBetween" wrap>
                        <FilterButton onPress={openFilters} />
                        <div>
                            <ProductListViewControls
                                viewMode={viewMode}
                                setViewMode={setViewMode}
                            />
                        </div>
                    </HStack>
                    <HStack justify="end">
                        {viewMode === 'stockList' && (
                            <ProductListCSVDownloadButton />
                        )}
                    </HStack>
                </VStack>
            </VStack>
        );
    }

    return (
        <HStack gap="small" align="center" justify="spaceBetween">
            <ProductListCategoryHeader
                header={header}
                subHeader={subHeader}
                totalLoading={totalLoading}
                total={totalCount}
                filteredTotal={filteredTotal}
                headerAction={headerAction}
            />
            <HStack align="center" gap="gap32" justify="end">
                {viewMode === 'stockList' && <ProductListCSVDownloadButton />}
                <ListControls small />
                <HStack align="center" gap="small" wrap>
                    <ProductListViewControls
                        viewMode={viewMode}
                        setViewMode={setViewMode}
                    />
                </HStack>
            </HStack>
        </HStack>
    );
};

export default memo(ProductListHeader);
